import type { DemCloudTalkCallGroup } from '../../types/dem';

type CloudTalkCallRowProps = {
  group: DemCloudTalkCallGroup;
  selected: boolean;
  /** Caller has matching DEM order contact number. */
  demLinked?: boolean;
  onSelect: (group: DemCloudTalkCallGroup) => void;
  onOpenDetail: (group: DemCloudTalkCallGroup) => void;
};

export function CloudTalkCallRow({
  group,
  selected,
  demLinked = false,
  onSelect,
  onOpenDetail,
}: CloudTalkCallRowProps) {
  const pending = group.status === 'Pending';
  const answered = group.status === 'Answered';
  const aiRow = group.groupKey.startsWith('insight:');
  const timeText =
    group.callCount > 1 ? `${group.displayTime} (${group.callCount} calls)` : group.displayTime;
  const resolvedBy = group.resolvedBy || '—';
  const callback = resolvedBy.includes('Callback');
  const statusClass = pending
    ? ' dem-cloudtalk-call-row__status--pending'
    : answered
      ? ' dem-cloudtalk-call-row__status--answered'
      : aiRow
        ? ' dem-cloudtalk-call-row__status--ai'
        : ' dem-cloudtalk-call-row__status--resolved';
  const statusLabel = pending
    ? 'Pending'
    : answered
      ? 'Answered'
      : aiRow
        ? group.status || 'AI'
        : 'Resolved';

  return (
    <button
      type="button"
      className={`dem-cloudtalk-call-row${selected ? ' dem-cloudtalk-call-row--selected' : ''}`}
      onClick={() => onSelect(group)}
      onDoubleClick={() => onOpenDetail(group)}
    >
      <span
        className={`dem-cloudtalk-call-row__time${group.callCount > 1 ? ' dem-cloudtalk-call-row__time--multi' : ''}`}
      >
        {timeText}
      </span>
      <span className="dem-cloudtalk-call-row__name dem-customer-cell--clip" title={group.contactName}>
        {group.contactName}
      </span>
      <span className="dem-cloudtalk-call-row__number">
        {group.callerNumber}
        {demLinked ? (
          <span className="dem-cloudtalk-call-row__dem" title="Matched DEM customer/order">
            DEM
          </span>
        ) : null}
      </span>
      <span className="dem-cloudtalk-call-row__line dem-customer-cell--clip" title={group.calledLine}>
        {group.calledLine}
      </span>
      <span className={`dem-cloudtalk-call-row__status${statusClass}`}>{statusLabel}</span>
      <span
        className={`dem-cloudtalk-call-row__resolved dem-customer-cell--clip${callback ? ' dem-cloudtalk-call-row__resolved--callback' : ''}`}
        title={resolvedBy}
      >
        {resolvedBy}
      </span>
    </button>
  );
}
